import { getPanelOptions } from '../utils';
import RadioListComponent from '72cms-ui/components/form-elements/RadioListComponent';

export default {
    sections: ['details'],
    toolbar: ['add', 'edit', 'active', 'delete'],
    fields: {
        type: {
            noTitle: true,
            section: 'details',
            readonly: true,
            position: 0,
            section: 'details',
            component: RadioListComponent,
            values: function (value) {
                return getPanelOptions([value]);
            },
        },
        name: {
            section: 'details',
            position: 1,
        },
        content: {
            section: 'details',
            position: 2,
            disabled: function (value, schema, data) {
                return data.local_page_id;
            },
        },
      
        content_id: {
            section: 'details',
            position: 4,
            disabled: function (value) {
                return !value;
            },
            component: {
                template: '<div role="success" class="alert alert-success"><img src="/img/icons/question-gr.svg" alt="Question"> {{ description }}</div>',
                props: ['description'],
            },
            description: 'This panel will use page images',
        }
    }
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/form.panel-values.js